export enum BookingOption {
  ENTIRE_OFFICE_HOUR = 'ENTIRE_OFFICE_HOUR',
  ENTIRE_OFFICE_HALF_DAY = 'ENTIRE_OFFICE_HALF_DAY',
  ENTIRE_OFFICE_FULL_DAY = 'ENTIRE_OFFICE_FULL_DAY',
  ONE_SEAT_2HOURS = 'ONE_SEAT_2HOURS',
  ONE_SEAT_FULL_DAY = 'ONE_SEAT_FULL_DAY',
  ONE_SEAT_WEEK = 'ONE_SEAT_WEEK',
  ONE_SEAT_MONTH = 'ONE_SEAT_MONTH',
  ONE_SEAT_QUICK_CARD_5D = 'ONE_SEAT_QUICK_CARD_5D',
  ONE_SEAT_QUICK_CARD_10D = 'ONE_SEAT_QUICK_CARD_10D',
  ONE_SEAT_90DAYS = 'ONE_SEAT_90DAYS',
  ONE_SEAT_180DAYS = 'ONE_SEAT_180DAYS',
  ONE_SEAT_360DAYS = 'ONE_SEAT_360DAYS',
}
